/**
 * Website theme — LOTE M (2026-06-24).
 *
 * The marketing site uses STILGIA's dark palette exclusively.
 */
import { palette, radius, spacing, fonts } from '@/src/theme';

export const wwwTheme = palette.dark;
export const wwwRadius = radius;
export const wwwSpacing = spacing;
export const wwwFonts = fonts;
export const wwwAccent = '#A78BFA';
